import type { LaborDomain } from "@/lib/labor/laborTarget";

const STORAGE_KEY = "integrator_hub_labor_departure_snapshot_v1";

export interface LaborDepartureSnapshot {
  sessionId: number;
  domain: LaborDomain;
  /** Tab that owns this snapshot; used to avoid ending another tab's session. */
  tabId: string;
  accessToken: string;
}

export function writeLaborDepartureSnapshot(snapshot: LaborDepartureSnapshot): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  if (snapshot.sessionId <= 0 || snapshot.accessToken.trim() === "" || snapshot.tabId.trim() === "") {
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
}

export function readLaborDepartureSnapshot(): LaborDepartureSnapshot | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === null || raw.trim() === "") {
      return null;
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") {
      return null;
    }
    const record = parsed as Record<string, unknown>;
    const sessionId = typeof record.sessionId === "number" ? record.sessionId : Number(record.sessionId);
    const domain = record.domain;
    const tabId = typeof record.tabId === "string" ? record.tabId.trim() : "";
    const accessToken = typeof record.accessToken === "string" ? record.accessToken.trim() : "";
    if (
      !Number.isFinite(sessionId) ||
      sessionId <= 0 ||
      tabId === "" ||
      accessToken === "" ||
      (domain !== "shipping" && domain !== "clampqc" && domain !== "manufacturing")
    ) {
      return null;
    }
    return {
      sessionId: Math.trunc(sessionId),
      domain,
      tabId,
      accessToken,
    };
  } catch {
    return null;
  }
}

export function clearLaborDepartureSnapshot(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(STORAGE_KEY);
}
